export default "assets/images/pattern-7f851a0c.png";